import script from "./UpdateToApprovedMenuDropDown.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateToApprovedMenuDropDown.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateToApprovedMenuDropDown.vue?vue&type=style&index=0&id=2e8f35c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8f35c8"]])

export default __exports__